export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "sittings": {
          "new_item": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add New Exam Sitting"])},
          "sub_location_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sitting ID:"])},
          "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There is no sitting data"])},
          "sitting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sitting"])},
          "sittings_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sittings"])},
          "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date:"])},
          "start_time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start Time:"])},
          "end_time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["End Time:"])},
          "update": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update"])},
          "exam_sittings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam Sittings"])}
        },
        "series": {
          "new_item": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add New Exam Series"])},
          "series_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Series"])},
          "exam_series": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam Series"])},
          "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There is no series data"])},
          "start_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start Date:"])},
          "end_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["End Date:"])},
          "update": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update"])}
        },
        "certificates": {
          "certificates_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container certificates"])},
          "new_item": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New container certificate"])},
          "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There is no certificate data"])},
          "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
          "last_updated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last updated:"])},
          "certificate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container certificate list"])}
        }
      },
      "fr": {
        "certificates": {
          "certificates_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["certificat de conteneur"])},
          "new_item": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau certificat de conteneur"])},
          "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
          "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])},
          "last_updated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dernière mise à jour :"])},
          "certificate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Liste des certificats de conteneur"])}
        }
      }
    }
  })
}